export enum ImageTypes {
	logoPdf = "logoPdf",
	logoHtml = "logoHtml",
	logoBar = "logoBar",
	None = "None"
}